<template>
    <div>
        <!-- List of exports -->

        <div class="table-responsive">
            <table class="table trax-simple-table mb-0" width="100%" style="width:100%">
                <tbody>

                    <!-- Procedures -->

                    <tr>
                        <td class="font-weight-bold">
                            {{ lang.polaris.procedure.atp_daf }}
                        </td>
                        <td class="text-right">

                            <button type="button" class="btn btn-white btn-sm ml-1"
                                @click="generateProcedures()"
                                v-if="exportPermission"
                            >
                                {{ lang.polaris.dashboard.generate }} CSV
                                <br v-if="procedures"><small v-if="procedures">{{ timestamp(procedures) }}</small>
                            </button>

                            <button type="button" class="btn btn-primary btn-sm ml-1"
                                @click="download('procedures')" :disabled="!procedures"
                            >
                                {{ lang.polaris.dashboard.download }} CSV
                            </button>
                        </td>
                    </tr>

                    <!-- Raw data -->

                    <tr>
                        <td class="font-weight-bold">
                            {{ lang.polaris.dashboard.raw_data }}
                            <br v-if="taskRunning"><small v-if="taskRunning" class="text-dark">{{ taskLabel }}</small>
                            <br v-if="taskFailed"><small v-if="taskFailed" class="text-danger">{{ taskLabel }}</small>
                        </td>
                        <td class="text-right">

                            <button type="button" class="btn btn-white btn-sm ml-1"
                                data-toggle="modal" :data-target="'#'+id+'-rawdata'"
                                :disabled="taskRunning"
                                v-if="exportPermission"
                            >
                                <i class="material-icons trax-spin" v-if="taskRunning">autorenew</i>
                                {{ lang.polaris.dashboard.generate }} CSV
                                <br v-if="rawData"><small v-if="rawData">{{ timestamp(rawData) }}</small>
                            </button>

                            <button type="button" class="btn btn-white btn-sm ml-1"
                                @click="cancelRawData()"
                                v-if="exportPermission && taskRunning"
                            >
                                {{ lang.polaris.tasks.cancel }}
                            </button>

                            <button type="button" class="btn btn-primary btn-sm ml-1"
                                @click="download('raw-data')" :disabled="!rawData || taskRunning"
                            >
                                {{ lang.polaris.dashboard.download }} CSV
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Modal for Raw Data params -->

        <trax-ui-modal-default :id="id+'-rawdata'" :bus="bus" title="Raw Data CSV">
            <enac-atpl-dashboard-export-global-rawdata-filters :id="id+'-rawdata'" :bus="bus" v-model="rawDataFilters" />
        </trax-ui-modal-default>

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" :passed-label="true"></trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: { default: 'enac-atpl-dashboard-export' }
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                app_url: app_url,
                endpoint: app_url+'polaris/api/front/export/global',
                procedures: null,
                rawData: null,
                task: null,
                timer: null,
                rawDataFilters: {
                    program_id: null,
                    cohort_id: null,
                    from: null,
                    to: null,

                    // Must agree with the checkbox of the filters form, which is ticked by default.
                    lane: 'night',
                },
                bus: this.$bus
            }
        },

        computed: {

            exportPermission: function() {
                return this.user.admin || this.user.permissions['export.generate'];
            },

            // The task is waiting for the runner, or running.
            taskRunning: function() {
                if (!this.task) return false;
                return ['pending', 'running', 'cancelling'].indexOf(this.task.status) >= 0;
            },

            taskFailed: function() {
                return this.task && this.task.status == 'failed';
            },

            taskLabel: function() {
                if (!this.task) return '';
                var label = this.lang.polaris.tasks[this.task.status];
                if (this.task.status == 'running' && this.task.progress_total) {
                    label += ' ' + this.task.progress + '/' + this.task.progress_total;
                }
                if (this.task.status == 'pending' && this.task.lane == 'night') {
                    label += ' (' + this.lang.polaris.tasks.night_run + ')';
                }
                return label;
            }
        },

        created: function() {
            this.getStates();
            this.bus.$on(this.id+'-rawdata-generate', this.generateRawData);
        },

        beforeDestroy: function() {
            this.stopPolling();
        },

        methods: {

            getStates() {
                var that = this;
                axios.get(this.endpoint)
                    .then(function (response) {
                        that.setState(response.data);
                    })
                    .catch(function (error) {
                    });
            },

            // The state always comes from the server, so that a page reload restores a running
            // export, whoever started it.
            setState(payload) {
                var items = payload.data;
                this.procedures = null;
                this.rawData = null;
                for (var index in items) {
                    var item = items[index];
                    if (item.type == 'procedures') this.procedures = item;
                    if (item.type == 'raw_data') this.rawData = item;
                }
                this.task = payload.raw_data_task;

                if (this.taskRunning) {
                    this.startPolling();
                } else {
                    this.stopPolling();
                }
            },

            startPolling() {
                if (this.timer) return;
                var that = this;
                this.timer = setInterval(function() {
                    axios.get(that.endpoint+'/raw-data/task')
                        .then(function (response) {
                            that.setState(response.data);
                        })
                        .catch(function (error) {
                            that.stopPolling();
                        });
                }, 3000);
            },

            stopPolling() {
                if (!this.timer) return;
                clearInterval(this.timer);
                this.timer = null;
            },

            generateProcedures() {
                var that = this;
                this.bus.$emit('loader-start-loading');
                axios.post(this.endpoint+'/procedures/generate')
                    .then(function (response) {
                        that.setState(response.data);
                        that.bus.$emit('loader-stop-loading');
                    })
                    .catch(function (error) {
                        that.bus.$emit('loader-stop-loading');
                    });
            },

            // The raw data export may run for hours: it is delegated to a task, so there is no
            // blocking loader here, only the state of the row.
            generateRawData() {
                var that = this;
                axios.post(this.endpoint+'/raw-data/generate', this.rawDataFilters)
                    .then(function (response) {
                        that.setState(response.data);
                    })
                    .catch(function (error) {
                        var message = error.response && error.response.data ? error.response.data.message : undefined;
                        that.bus.$emit(that.id+'-toastr-error', message);
                    });
            },

            cancelRawData() {
                var that = this;
                axios.post(this.endpoint+'/raw-data/cancel')
                    .then(function (response) {
                        that.setState(response.data);
                    })
                    .catch(function (error) {
                    });
            },

            download(type) {
                window.open(this.endpoint+'/'+type+'/file');
            },

            timestamp(item) {
                return moment(item.updated_at).format('DD/MM/YYYY H:mm:ss');
            }
        }
    }
</script>
